var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        {
          directives: [
            { name: "popover", rawName: "v-popover:popover4", arg: "popover4" }
          ],
          staticClass: "pointer"
        },
        [_vm._t("triggerbutton", [_vm._v("trigger")])],
        2
      ),
      _vm._v(" "),
      _c(
        "el-popover",
        {
          ref: "popover4",
          attrs: {
            placement: "right",
            transition: "",
            "popper-class": "listing-dropdown",
            trigger: "hover"
          }
        },
        [
          _vm._t("content", [_vm._v("No data")]),
          _vm._v(" "),
          _vm._t("actionbuttons")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }